<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto ink-gradient-dialog-root" [dir]="isRTL ? 'rtl' : 'ltr'">

  <div class="position-absolute w-100 d-flex zx-z-index-1" [class.justify-content-end]="isRTL">
    <button type="button" mat-icon-button aria-label="Close" (click)="closeDialog()"
      class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="d-flex flex-grow-1 flex-column px-3 pt-4 pb-3 px-md-4 pt-md-4 gap-3 w-100 position-relative ink-gradient-dialog-body">

    <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.text-white]="isDarkMode">
      {{ "printing-table.ink-gradient-dialog.title" | translate }}
    </h4>

    <div class="ink-gradient-file-summary w-100 rounded-3 p-3" [class.ink-gradient-panel--dark]="isDarkMode">
      <div class="fw-bold text-break" [class.text-white]="isDarkMode">{{ fileName }}</div>
      <div class="zx-text-small mt-2" [class.text-white]="isDarkMode">
        <span class="ink-gradient-kv-label">{{ "su-management.order-num-of-pages" | translate }}:</span>
        <span class="fw-semibold">{{ images.length }}</span>
      </div>
    </div>

    <div class="w-100 d-flex flex-column gap-3">
      <div *ngFor="let image of images; let i = index" class="ink-gradient-page-card rounded-3 p-3"
        [class.ink-gradient-panel--dark]="isDarkMode">
        <div class="fw-bold mb-3" [class.text-white]="isDarkMode">
          {{ "printing-table.white-page-deleted-multi-1" | translate }}{{ getPageNumber(image, i) }}
        </div>

        <div class="d-flex flex-column flex-md-row gap-3 align-items-start">
          <div class="ink-gradient-thumbnail-wrap flex-shrink-0" *ngIf="image.thumbnailPath || image.path">
            <img [src]="getThumbnailUrl(image)" [alt]="fileName" class="ink-gradient-thumbnail">
          </div>

          <div class="flex-grow-1 min-w-0 w-100">
            <div class="zx-text-small mb-3" [class.text-white]="isDarkMode">
              <span class="ink-gradient-kv-label">{{ "printing-table.cover" | translate }}:</span>
              <span class="fw-semibold">{{ roundPercent(image.inkLevel) }}%</span>
            </div>

            <div *ngIf="image.inkGradient?.length > 0" class="ink-gradient-list">
              <div *ngFor="let item of image.inkGradient" class="ink-gradient-row zx-text-small"
                [class.text-white]="isDarkMode">
                <span class="ink-gradient-range">{{ item.range }}</span>
                <span class="ink-gradient-separator">|</span>
                <span class="fw-semibold">{{ roundPercent(item.percent) }}%</span>
              </div>
            </div>

            <div *ngIf="!image.inkGradient?.length" class="zx-text-small opacity-75" [class.text-white]="isDarkMode">
              {{ "printing-table.ink-gradient-dialog.no-data" | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center pt-2 pb-1 w-100">
      <button type="button" mat-raised-button color="primary" (click)="closeDialog()"
        class="rounded-pill px-4 fw-bold text-white ink-gradient-close-btn">
        {{ "error-content-ok-btn" | translate }}
      </button>
    </div>
  </div>
</div>
